import buhleImg from "../Images/Singers/BuhleThela.jpeg";
import kekeImg from "../Images/Singers/KekePhofolo.jpeg";
import kgaugeloImg from "../Images/Singers/KgaugeloKekana.jpg";
import mikeImg from "../Images/Singers/Mike.jpg";
import lucasImg from "../Images/Singers/LucasMaloma.jpeg";
import musaImg from "../Images/Singers/Musa.jpeg";
import nomandlaImg from "../Images/Singers/Nomandla.jpeg";
import victorelImg from "../Images/Singers/Victorel.jpeg";
import xoliImg from "../Images/Singers/Xoli.jpeg";

function Artists() {
  const artists = [
    { name: "PS. Buhle Thela", image: buhleImg },
    { name: "Keke Phoofolo", image: kekeImg },
    { name: "Kgaugelo Kekana", image: kgaugeloImg },
    { name: "PS. Michael David", image: mikeImg },
    { name: "Lucas Maloma", image: lucasImg },
    { name: "Musa Yende", image: musaImg },
    { name: "Nomandla Sandra", image: nomandlaImg },
    { name: "Victorel Molaba", image: victorelImg },
    { name: "Xoli Thabethe", image: xoliImg }
  ];

  return (
    <section
      id="artists"
      style={{
        padding: "80px 20px",
        textAlign: "center",
        background: "#f9f9f9"
      }}
    >
      <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>
        Artists
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "25px",
          flexWrap: "wrap"
        }}
      >
        {artists.map((artist, index) => (
          <div
            key={index}
            style={{
              width: "240px",
              background: "white",
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #eee",
              boxShadow: "0 6px 18px rgba(0,0,0,0.06)"
            }}
          >
            {/* IMAGE WRAPPER */}
            <div
              style={{
                width: "100%",
                height: "280px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start", // pushes image slightly down
                paddingTop: "12px",       // top spacing
                background: "#fff"
              }}
            >
              <img
                src={artist.image}
                alt={artist.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  borderRadius: "10px" // 👈 rounded corners added
                }}
              />
            </div>

            {/* NAME ONLY */}
            <div style={{ padding: "15px" }}>
              <h3 style={{ margin: 0 }}>
                {artist.name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Artists;